import React, { createContext, useContext, useState } from "react";

const SettingsContext = createContext("");

export function SettingsContextProvider({ children }) {
  const scrollUpRef = React.createRef();

  const companyObject = [
    {
      companyId: null,
      companyName: "",
    },
  ];

  const businessObject = [
    {
      businessId: "",
      businessName: "",
    },
  ];

  const [company, setCompanyName] = useState(companyObject);
  const [businessType, setBusinessType] = useState(businessObject);
  const [imageUploadFile, setImageUploadFile] = useState([]);

  return (
    <SettingsContext.Provider
      value={{
        company,
        setCompanyName,
        businessType,
        setBusinessType,
        scrollUpRef,
        imageUploadFile,
        setImageUploadFile,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettingsContext() {
  return useContext(SettingsContext);
}
